import * as React from 'react';
import Head from 'next/head';
import { DefaultPageProps } from 'types';
import { defaultGetStaticProps } from 'utils/staticPropsHelper';
import { getHeaderTitle } from 'utils/string';
import { BLOG_LIST_TYPE, BlogItemBase, getBlogListByType } from 'utils/contentful/blog';
import BlogContainer from 'containers/Blog';
import { useTranslation } from 'next-i18next';

type ReferralCodePageProps = DefaultPageProps & {
  items: Array<BlogItemBase>;
};

const ReferralCodePage: React.FC<ReferralCodePageProps> = ({ items }) => {
  const { t } = useTranslation();
  return (
    <div className="LegalPage w-full">
      <Head>
        <title>{getHeaderTitle(t('blog.meta.title') as string)}</title>
      </Head>
      <BlogContainer items={items} />
    </div>
  );
};

export const getStaticProps = async (context: any) => {
  const { preview } = context;
  const { props } = await defaultGetStaticProps(context);
  let items;

  try {
    items = await getBlogListByType({ type: BLOG_LIST_TYPE.GENERAL, preview, locale: props.lang });
    if (!items) {
      return {
        notFound: true
      };
    }
  } catch (e: any) {
    const error = JSON.parse(e);
    if (error.status === 404) {
      return {
        notFound: true
      };
    }
    console.error('Error fetching blogs:', e);
  }

  return {
    props: {
      ...props,
      items: items || null
    },
    revalidate: 10
  };
};

export default ReferralCodePage;
